import { createApi } from '@reduxjs/toolkit/query/react'

import { UploadLogoResponse } from './types'
import { baseQuery } from '../../query'

export const companyApi = createApi({
  reducerPath: 'company',
  baseQuery,
  endpoints: (builder) => ({
    uploadLogo: builder.mutation<UploadLogoResponse, { data: FormData }>({
      query: ({ data }) => ({
        url: 'api/company/logo/extract-colors',
        method: 'POST',
        body: data,
      }),
    }),
  }),
})

export const { useUploadLogoMutation } = companyApi
